import React from "react";
import { Globe, X, Loader2 } from "lucide-react";

// A real closed-captions surface: the single latest line up top (big, like
// Zoom/Teams captions), full translated history below. Independent of the
// Transcript panel, which stays English-only — this is the "read it in your
// own language" surface.
export default function CaptionsPanel({ languages, captionLang, setCaptionLang, lines, captions, onClose }) {
  const latest = captionLang ? lines[lines.length - 1] : null;
  const latestCaption = latest && captions[latest.timestamp]?.language === captionLang ? captions[latest.timestamp].text : null;

  return (
    <>
      <div style={{ padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Globe size={14} color="#00C8FF" />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#E8F0FE" }}>Live Captions</span>
        </div>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#7A93B4" }}><X size={15} /></button>
      </div>

      <div style={{ padding: "12px 18px", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <select value={captionLang} onChange={(e) => setCaptionLang(e.target.value)}
          style={{ width: "100%", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 8,
            color: "#E8F0FE", fontSize: 12, fontFamily: "Outfit,sans-serif", padding: "7px 9px", cursor: "pointer" }}>
          <option value="">Off — show original only</option>
          {languages.map((l) => <option key={l.code} value={l.code}>{l.name}</option>)}
        </select>
      </div>

      {captionLang ? (
        <>
          <div style={{ padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
            <div style={{ fontSize: 10, color: "#3D5473", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Now speaking</div>
            {!latest ? (
              <div style={{ fontSize: 12.5, color: "#3D5473" }}>Waiting for someone to speak…</div>
            ) : latestCaption ? (
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#00C8FF", marginBottom: 3 }}>{latest.speaker}</div>
                <div style={{ fontSize: 15, color: "#E8F0FE", lineHeight: 1.5, fontWeight: 600 }}>{latestCaption}</div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#7A93B4", fontSize: 12.5 }}>
                <Loader2 size={13} className="hm-spin" /> Translating…
              </div>
            )}
          </div>
          <div className="hm-scroll" style={{ flex: 1, overflowY: "auto", padding: "12px 18px" }}>
            {lines.slice(0, -1).reverse().map((l, i) => {
              const c = captions[l.timestamp];
              if (!c || c.language !== captionLang) return null;
              return (
                <div key={i} className="hm-line" style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: "#7A93B4" }}>{l.speaker}</div>
                  <div style={{ fontSize: 12.5, color: "#C8D6E8", lineHeight: 1.5 }}>{c.text}</div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center", color: "#3D5473", fontSize: 12.5 }}>
          Pick a language above to see live translated captions as people speak.
        </div>
      )}
    </>
  );
}
